import { FC, useEffect, useState } from 'react';

import { Hero } from '../../components/Hero/Hero';
import { EasyAs } from '../../components/EasyAs/EasyAs';
import { YourSix } from '../../components/YourSix/YourSix';
import { TakingBackControl } from '../../components/TakingBackControl/TakingBackControl';
import { Agenda } from '../../components/Agenda/Agenda';
import { About } from '../../components/About/About';
import { Partners } from '../../components/Partners/Partners';

import { scrollTop } from '../../helpers/scrollTop';

type Props = {
  isMenuOpened: boolean;
  closeMenu: () => void;
};

export const Home: FC<Props> = ({ isMenuOpened, closeMenu }) => {
  useEffect(() => {
    scrollTop();
  });

  return (
    <>
      <Hero isMenuOpened={isMenuOpened} closeMenu={closeMenu} />

      <Agenda />

      <EasyAs />

      <YourSix />

      <TakingBackControl />

      <Partners />

      <About />
    </>
  );
};
